import memoizeSelector from '@/redux/lib/memoizeSelector';
import selectors from '@/redux/selectors/selectors';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const useLoadedPermissions = (requiredPermissions = []) => {
  const permissions = useSelector(memoizeSelector('permissions', selectors.permissions));
  const isLoaded = useSelector(selectors.authorizationLoaded);
  const companyId = useSelector(selectors.companyId);
  const [grantedCompanyId, setGrantedCompanyId] = useState(null);

  const missingPermissions = isLoaded ? requiredPermissions.filter((n) => !permissions.includes(n)) : [];
  const isGranted = isLoaded && missingPermissions.length === 0;
  const loadedGrantCompanyId = isGranted ? companyId : null;

  if (isLoaded && grantedCompanyId !== loadedGrantCompanyId) {
    setGrantedCompanyId(loadedGrantCompanyId);
  }

  const isAllowed = isGranted || (!isLoaded && Boolean(companyId) && grantedCompanyId === companyId);

  return { isAllowed, isPending: !isLoaded && !isAllowed, missingPermissions };
};

export default useLoadedPermissions;
